<template>
  <div class="self_adaption">
    <div class="self_adaption_main">
      <el-form ref="form" :model="form" label-width="96px" label-position="right" class="FormFlex"
               style="justify-content: space-between;">
        <el-form-item class="width25" label="发布会主题">
          <el-input v-model="form.title" placeholder="请输入会议主题名称"></el-input>
        </el-form-item>
        <el-form-item class="width25" label="主办单位">
          <el-input v-model="form.unit" placeholder="请输入主办单位名称"></el-input>
        </el-form-item>
        <el-form-item class="width25" label="发布会时间">
          <el-date-picker v-model="form.startTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
        <el-form-item class="width25" label="地点">
          <el-input v-model="form.address" placeholder="请输入发布会地点"></el-input>
        </el-form-item>
        <el-form-item class="width100" label="发布会简介">
          <el-input type="textarea" v-model="form.intro" :autosize="{ minRows: 6, maxRows: 8 }" show-word-limit
                    maxlength="2000"></el-input>
        </el-form-item>
        <el-divider content-position="left">添加主持人</el-divider>
        <div class="FormFlex" v-for="(item, index) in hostList" :Key="index">
<!--          <el-form-item class="width400" label="单位">
            <el-input v-model="item.unit" placeholder="请输入单位名称"></el-input>
          </el-form-item>-->
          <el-form-item class="width400" label="单位及职务">
            <el-input v-model="item.duty" placeholder="请输入职务"></el-input>
          </el-form-item>
          <el-form-item class="width400" label="姓名">
            <el-input v-model="item.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item class="width400" label="">
            <el-button size="mini"  type="danger" icon="el-icon-minus" @click="del('host',item)"></el-button>
            <el-button size="mini"   v-show="!index" type="success" icon="el-icon-plus" @click="add('host')"></el-button>

          </el-form-item>
        </div>
        <el-divider content-position="left">添加发言人</el-divider>
        <div class="FormFlex" v-for="(item, index) in spokesmanList" :Key="index">
<!--          <el-form-item class="width400" label="单位">
            <el-input v-model="item.unit" placeholder="请输入单位名称"></el-input>
          </el-form-item>-->
          <el-form-item class="width400" label="单位及职务">
            <el-input v-model="item.duty" placeholder="请输入职务"></el-input>
          </el-form-item>
          <el-form-item class="width400" label="姓名">
            <el-input v-model="item.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item class="width400" label="">
            <el-button size="mini"  type="danger" icon="el-icon-minus"
                       @click="del('spokesman',item)"></el-button>
            <el-button size="mini"  v-show="!index" type="success" icon="el-icon-plus"
                       @click="add('spokesman')"></el-button>

          </el-form-item>
        </div>
      </el-form>
      <div class="submitDiv">
        <el-button type="success" @click="submit()">确认</el-button>
        <el-button @click="back()">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {surveyDetail, surveySave,delAttendee} from '@/api/axiosUrl';
  import {getYearMonthDay} from '@/utils/jsApi.js'

  export default {
    name: 'Progress',
    components: {},
    data() {
      return {
        dataId: '',
        form: {},
        hostList: [{
          unit: '',
          duty: '',
          name: '',
          type: '0'
        }],
        spokesmanList: [{
          unit: '',
          duty: '',
          name: '',
          type: '1'
        }]
      };
    },
    created() {
      this.dataId = this.$route.query.id;
      if (this.dataId) {
        surveyDetail({surveyId: this.dataId}).then(res => {
          if (res.status === 200) {
            this.form = res.data.survey
            this.hostList = []
            this.spokesmanList = []
            res.data.attendees.forEach(item => {
              if (item.type === 0) {
                this.hostList.push(item)
              }
              if (item.type === 1) {
                this.spokesmanList.push(item)
              }
            })
          }
        })
      }
    },
    methods: {
      add(flag) {
        if (flag == 'spokesman') {
          this.spokesmanList.push({
            unit: '',
            duty: '',
            name: '',
            type: '1'
          })
        } else {
          this.hostList.push({
            unit: '',
            duty: '',
            name: '',
            type: '0'
          })
        }
      },
      del(flag,item) {
        if (flag == 'spokesman') {
          var index = this.spokesmanList.indexOf(item)
          if (this.spokesmanList.length == 1) {
            this.Messager('至少保留一个', 'warning')
          } else {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              delAttendee({id: item.id}).then(res => {
                if (res.status === 200) {
                  this.Messager('删除成功', 'success')
                  this.spokesmanList.splice(index, 1)
                } else {
                  this.Messager('删除失败', 'error')
                }
              });
            })

          }
        } else {
          var index2 = this.hostList.indexOf(item)
          if (this.hostList.length == 1) {
            this.Messager('至少保留一个', 'warning')
          } else {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              delAttendee({id: item.id}).then(res => {
                if (res.status === 200) {
                  this.Messager('删除成功', 'success')
                  this.hostList.splice(index2, 1)
                } else {
                  this.Messager('删除失败', 'error')
                }
              });
            })
          }
        }
      },
      submit() {
        var _this = this
        var params = {}
        params.survey = JSON.parse(JSON.stringify(this.form))
        params.survey.startTime = getYearMonthDay(this.form.startTime, 'yy--ss')
        console.log(params.survey.startTime)
        params.attendees = []
        for (let i = 0; i < this.hostList.length; i++) {
          params.attendees.push(this.hostList[i])
        }
        for (let i = 0; i < this.spokesmanList.length; i++) {
          params.attendees.push(this.spokesmanList[i])
        }
        surveySave(params).then(res => {
          if (res.status == 200) {
            this.Messager('保存成功', 'success')
            setTimeout(function () {
              _this.back()
            }, 500)
          }
        });
      },
      back() {
        this.$router.push('/list')
      },
      //警告提示
      Messager(text, messageType) {
        this.$message({message: text, type: messageType})
      }
    }
  };
</script>

<style scoped>
  .width284 {
    width: 284px;
  }
  .width400{
    width: 400px;
  }
</style>
